import { Component, OnInit } from '@angular/core';

/**
 * Minimal callback page for the web-based Google OAuth popup flow.
 * Google redirects here with `?code=...` after the user approves access.
 * This page posts the code up to the opener window and closes itself.
 */
@Component({
  standalone: true,
  selector: 'app-oauth-callback',
  template: `
    <div style="display:flex;align-items:center;justify-content:center;height:100vh;
                font-family:sans-serif;color:#6b7280;font-size:14px;flex-direction:column;gap:12px">
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" stroke-width="2">
        <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
      </svg>
      <span>Completing Google sign-in…</span>
    </div>
  `
})
export class OAuthCallbackComponent implements OnInit {
  ngOnInit(): void {
    const params = new URLSearchParams(window.location.search);
    const code  = params.get('code');
    const error = params.get('error');

    if (window.opener) {
      // Popup flow — send result to parent and close
      window.opener.postMessage({ type: 'GOOGLE_OAUTH_CALLBACK', code, error }, window.location.origin);
      window.close();
    } else {
      // Redirect flow fallback — store in sessionStorage for the app to pick up
      if (code)  sessionStorage.setItem('google_oauth_code', code);
      if (error) sessionStorage.setItem('google_oauth_error', error);
      window.location.href = '/';
    }
  }
}
